import React, { useState } from "react";
import { FaEye } from "react-icons/fa";
import EnquiryDetailsModal from "../../Modals/EnquiryDetailsModal";

const RejectInquiry = ({ inquiries, loading }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedInquiry, setSelectedInquiry] = useState(null);

  const openModal = (inquiry) => {
    setSelectedInquiry(inquiry);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedInquiry(null);
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full border border-gray-200 rounded-lg shadow-lg">
        <thead className="bg-gradient-to-r from-[#0070a8] to-[#023955] text-white">
          <tr>
            {["Name", "Contact", "Email", "Certificate", "Date", "Actions"].map(
              (col) => (
                <th
                  key={col}
                  className={`px-4 py-3 text-left text-sm md:text-base font-semibold uppercase tracking-wider ${
                    col === "Actions" ? "text-center" : ""
                  }`}
                >
                  {col}
                </th>
              )
            )}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {loading ? (
            Array.from({ length: 5 }).map((_, index) => (
              <tr key={index} className="animate-pulse">
                {Array.from({ length: 6 }).map((__, idx) => (
                  <td
                    key={idx}
                    className="px-4 py-4 whitespace-nowrap bg-gray-100 rounded"
                  >
                    &nbsp;
                  </td>
                ))}
              </tr>
            ))
          ) : inquiries && inquiries.length > 0 ? (
            inquiries.map((inq) => (
              <tr
                key={inq._id}
                className="hover:bg-[#f0f8ff] transition-colors duration-300"
              >
                <td className="px-4 py-3 text-gray-900 font-medium">
                  {inq.name || "N/A"}
                </td>
                <td className="px-4 py-3 text-gray-800">
                  {inq.mobile || "N/A"}
                </td>
                <td className="px-4 py-3 text-gray-800 truncate max-w-[180px]">
                  {inq.email || "example@gmail.com"}
                </td>
                <td
                  className="px-4 py-3 text-gray-800 truncate max-w-[180px]"
                  title={inq.subject}
                >
                  {inq.subject
                    ? inq.subject.length > 20
                      ? inq.subject.slice(0, 20) + "..."
                      : inq.subject
                    : "N/A"}
                </td>
                <td className="px-4 py-3 text-gray-800">
                  {inq.createdAt
                    ? new Date(inq.createdAt).toLocaleDateString()
                    : "N/A"}
                </td>
                <td className="px-4 py-3 text-center">
                  <button
                    onClick={() => openModal(inq)}
                    className="p-1 rounded-full bg-gradient-to-r from-[#4a90e2] to-[#357abd] hover:from-[#5ba0f2] hover:to-[#4a90e2] text-white transition-all"
                    title="View Details"
                  >
                    <FaEye size={20} />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan="6"
                className="text-center py-6 text-gray-500 text-sm"
              >
                No rejected inquiries
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <EnquiryDetailsModal
        isOpen={isModalOpen}
        onClose={closeModal}
        inquiry={selectedInquiry}
      />
    </div>
  );
};

export default RejectInquiry;
